export default "__VITE_PUBLIC_ASSET__7f6e322a__"